import { TranslationsProvider } from '@teliaee/telia-translate';
import { observer, Provider } from 'mobx-react';
import * as React from 'react';
import { Main, TBgColor, ThemeProvider } from 'telia-front-react';

import icons from '@teliaee/icons/sprite.svg';
import config from './config';
import { QueryParam } from './Constants';
import Content from './Content';
import RootStore from './stores/RootStore';
import BrandUtil from './utils/BrandUtil';
import ErrorUtil from './utils/ErrorUtil';
import { getApiUrl } from './utils/UrlUtil';
import TeliaLabelProvider from './wrappers/TeliaLabelProvider';

import './css/global';
import { resolveAppStyles } from './utils/StyleUtil';

interface IAppState {
  hasError: boolean;
  brand: Brand;
}

@observer
class App extends React.Component<unknown, IAppState> {
  private readonly rootStore: RootStore;

  constructor(props: unknown) {
    super(props);
    resolveAppStyles();
    this.rootStore = new RootStore();
    this.state = {
      hasError: false,
      brand: (this.rootStore.routeStore.queryParam(QueryParam.Brand) as Brand) || 'TELIA',
    };
  }

  public componentDidMount(): void {
    this.rootStore.sessionStore.loadSession();
  }

  public componentDidCatch(error: Error): void {
    this.setState({ hasError: true });
    ErrorUtil.registerError(error);
  }

  private getCustomBackgroundColor() {
    return this.rootStore.routeStore.queryParam('backgroundColor');
  }

  public render(): JSX.Element {
    const brand = BrandUtil.getBrandType(this.state.brand).toLowerCase();
    const lang = this.rootStore.languageStore.currentLanguage;
    const tier = config.frontendEnvironmentName;
    return (
      <Provider {...this.rootStore}>
        <ThemeProvider
          getIconPath={(name) => icons + name}
          locale={this.rootStore.languageStore.currentLocale}
          // @ts-ignore
          brand={brand}
          theme={brand === 'super' ? 'dark' : undefined}
        >
          <TranslationsProvider
            labelsUrl={`${getApiUrl(tier)}/translations/${lang}`}
            defaultApp={'brandfreepp'}
            lang={lang}
            tier={tier}
            includeGlobalTranslations={false}
            disableStatistics={true}
          >
            <TeliaLabelProvider>
              <Main background={this.getCustomBackgroundColor() as TBgColor}>
                <Content hasError={this.state.hasError} />
              </Main>
            </TeliaLabelProvider>
          </TranslationsProvider>
        </ThemeProvider>
      </Provider>
    );
  }
}

export default App;
